import React, { RefObject, useMemo } from 'react';
import classNames from 'classnames/bind';
import { useWeb3React } from '@web3-react/core';
import scrollDownImg from '@assets/images/home/scrollDown.svg';
import bgSm from '@assets/images/home/bg-sm.png';
import bgLg from '@assets/images/home/bg-lg.png';
import bgXl from '@assets/images/home/bg-xl.png';
import goldCube from '@assets/images/gold-cube.png';
import silverCubes from '@assets/images/silver-cube.png';
// import {
//   Loader,
// } from '../Loader';
// import { ConnectButton } from '../../../../components/connect-button';
import { ConnectButton } from '@components';
import styles from './styles.module.scss';
import { Container } from '../Container';

const cx = classNames.bind(styles);

type MainProps = {
  refSection: RefObject<HTMLDivElement>;
  refSection2: RefObject<HTMLDivElement>;
  onScrollDown: () => void;
  onConnectWallet: () => void;
  isLoader: boolean;
};

const SectionMain = ({
  refSection, onScrollDown,
  refSection2,
}: MainProps) => {
  const {
    active,
  } = useWeb3React();

  const isShow = useMemo(() => active, [active]);

  return (
    <section className={styles.containerMain}>
      <div ref={refSection} />
      <Container>
        {/* <img src={mainLeft} alt="" className={styles.mainLeft} /> */}
        <img src={bgSm} alt="" className={styles.bgSm} />
        <img src={bgLg} alt="" className={styles.bgLg} />
        <img src={bgXl} alt="" className={styles.bgXl} />

        <img src={goldCube} alt="" className={styles.goldCube} />
        <img src={silverCubes} alt="" className={styles.silverCube} />
        <div className={styles.bg}>

          {/* <video className={styles.video} autoPlay loop muted>
        <source src="/background.mp4" type="video/mp4" />
      </video> */}
          <p className={styles.title}>
            represent
            <span className={styles.titleInner}>
              vote
            </span>
          </p>
          <p className={styles.subtitle}>
            {/* eslint-disable-next-line max-len, react/no-unescaped-entities */}
            the people's platform
          </p>
          <p className={styles.textInfo}>
            {/* eslint-disable-next-line max-len */}
            from communities to nations, representVote empowers people to organize and decide—securely, transparently, and in real time. every vote is protected by blockchain, geographically anchored, free from centralized control, and personally verifiable - by you.
          </p>

          <div className={`${styles.connectButton} ${active ? styles.connectButtonActive : ''}`}>
            <ConnectButton />
          </div>
          <div className={styles.containerBottom}>
            <button
              type="button"
              className={cx(
                styles.buttonScrollDown,
                { hideClass: isShow, classButtonNoDelay: active },
              )}
              onClick={onScrollDown}
            >
              Scroll Down
              <img
                src={scrollDownImg}
                alt="scroll down"
                className={styles.scrollImg}
              />
            </button>
          </div>
        </div>
        <div className={styles.videoSection} ref={refSection2}>

          <iframe
            src="https://www.youtube.com/embed/amKMnyVsJh0"
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        {/* <Loader isShow={isShow} isShowConnectButton={isLoader && !active} /> */}
      </Container>
    </section>
  );
};

export { SectionMain };
